import { UserService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type MutationVariables = {
  uid: string;
  photo: Blob;
};

export const useSendUserPhotoMutation = (
  options?: Omit<
    UseMutationOptions<Awaited<ReturnType<typeof UserService.putUsersPhoto>>, QueryError, MutationVariables, unknown>,
    'mutationFn'
  >
) =>
  useMutation(({ uid, photo }: MutationVariables) => UserService.putUsersPhoto(uid, { Photo: photo }), {
    ...options,
    onSuccess: () => {
      toast.success('Successfully updated!');
    },
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });
